export default "__VITE_ASSET__DMBMVaRF__"